export default "__VITE_ASSET__C6SjWLCS__"